const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const SEPERATOR = require('../../utils/constants');
const base64 = require('base-64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    search(inputParam, metaData) {

      const url = getUrl('trades/search');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const channel = params[0];
      const limit = params[1];
      const pageId = params[2];
      const searchCriteria = JSON.parse(base64.decode(params[3]));
      const businessUnitId = params[4];

      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        channel: channel,
        branchCode: apiConfig.branchCode,
        page: {
          limit: limit,
          pageId: pageId
        },
        searchCriteria,
        businessUnitId
      };

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    assetSearch(inputParam, metaData) {

      const url = getUrl('assets/search');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const channel = params[0];
      const assetSearchString = params[1];
      const limit = params[2];
      const offset = params[3];
      const securityTypes = JSON.parse(base64.decode(params[4])) || [];
      const sortings = JSON.parse(base64.decode(params[5])) || [];

      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        channel: channel,
        branchCode: apiConfig.branchCode,
        assetSearchString: assetSearchString,
        page: {
          limit: limit,
          offset: offset
        },
        securityTypes: securityTypes,
        sortings: sortings
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getSingleSecurityDetail(inputParam, metaData) {

      const url = getUrl('assets/get');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const channel = params[0];
      const assetId = params[1];

      const body = {
        channel: channel,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId,
        assetId: assetId
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getAssetsLookupData(inputParam, metaData) {

      const url = getUrl('assets/lookup');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const securitySearchString = params[0];
      const channel = params[1];
      const limit = params[2];
      const pageId = params[3];
      const offset = params[4];

      const body = {
        channel: channel,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId,
        assetSearchString: securitySearchString,
        page: {
          limit: limit,
          pageId: pageId,
          offset: offset
        }
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    cancelOrder(inputParam, metaData) {

      const url = getUrl('trades/cancel');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const txType = params[0];
      const txToken = params[1];
      const orderId = params[2];
      const channel = params[3];
      const deviceCode = params[4];

      const body = {
        channel: channel,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId,
        deviceCode: deviceCode,
        txType: txType,
        txToken: txToken,
        order: {
          orderId: orderId
        }
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    approveOrder(inputParam, metaData) {

      const url = getUrl('trades/approve');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const txType = params[0];
      const txToken = params[1];
      const orderId = params[2];
      const channel = params[3];
      const deviceCode = params[4];

      const body = {
        channel: channel,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId,
        deviceCode: deviceCode,
        txType: txType,
        txToken: txToken,
        order: {
          orderId: orderId
        }
      }

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    }
  };
}



module.exports = apiFactory;
